import { RequestFloorDTO } from '@/dto/responseDto/request-floor.dto';
import http from '@/httpCommon/axiosClient';
import axios from 'axios';
// import { removeEmptyObject } from '@/util/object';

class Staff {
    getFloor = async (id: string) => {
        const res: any = await http.get(`/floor?storeId=${id}`);

        return res?.data?.data;
    };

    getListFloor = async () => {
        const res: any = await http.get('/phong/tang');
        if (res?.data?.statusCode && res?.data?.statusCode == 200) {
            return res?.data?.data || [];
        }
        return [];
    };

    getRoomByFloor = async (floor: string, status: number[] | undefined) => {
        const res: any = await http.get(`/phong/phong?floorId=${floor}&status=${status}`);
        if (res?.data?.statusCode && res?.data?.statusCode == 200) {
            return res?.data?.data || [];
        }
        return [];
    };

    getInfo = async () => {
        const res: any = await http.get(`/booking/order/getinfo`);
        if (res?.data?.statusCode && res?.data?.statusCode == 200) {
            return res?.data;
        }
        return {};
    };

    doiPhong = async (order: string, phong: string) => {
        const res: any = await http.post(`/booking/order/doiphong`, {
            order,
            phong,
        });
        if (res?.data?.statusCode && res?.data?.statusCode == 200) {
            return res?.data;
        }
        return {};
    };

    delete = async (id: string | number) => {
        const res = await http.delete(`/phong/tang/${id}`);
        return res?.data;
    };

    getAll = async () => {
        const res = await http.get('/phong/tang');
        return res?.data;
    };

    detail = async (id: string) => {
        const res = await http.get(`/phong/tang/${id}`);
        return res?.data;
    };

    create = async (body: RequestFloorDTO) => {
        const res = await http.post('/phong/tang', body);
        return res?.data;
    };

    update = async (id: string | number, body: RequestFloorDTO) => {
        const res = await http.put(`/phong/tang/${id}`, body);
        return res?.data;
    };
}
export default new Staff();
